import $ from 'jquery';
import scrollTo from 'utils/scroll-to';
import { isValidText, isValidEmail, isValidNumber } from '../form-elements/validation';

// helper: personal form field type and validation function
const endAbuseTypes = () => [
    {
        type: 'text',
        tag: 'input',
        func: isValidText
    },
    {
        type: 'email',
        tag: 'input',
        func: isValidEmail
    },
    {
        type: 'number',
        tag: 'input',
        func: isValidNumber
    }
];

const isValidDetail = ($form, fieldTypes) => {
    if ($form.length === 0) return true;

    let valid = true;
    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const doValidate = (el, func) => {
        if (!func($(el))) valid = false; // make sure it only change to false
    };

    // clear button error
    $buttonWraper.removeClass('Error');

    for (let i = 0; i < fieldTypes.length; i += 1) {
        if (typeof (fieldTypes[i].func) === 'function') {
            $form.find(`.${fieldTypes[i].type} ${fieldTypes[i].tag}`)
                .each((index, element) => doValidate(element, fieldTypes[i].func));
        }
    }

    // return true or show error
    if (valid) return true;

    // Not valid, add error class and scroll up to error field
    $buttonWraper.addClass('Error');
    scrollTo('.js-error', 100);
    return false;
};

/* helper: validate single input base on type
* validate on change
* validate on keyup if it already error
*/
const validateInputByType = ($form, type, validationFunction, callback) => {
    $form.find(`.${type} input`)
        .on('change', function () { // on change
            validationFunction($(this), callback);
        })
        .keyup(function () { // on keyup only when it has error
            const $el = $(this);
            if ($el.closest('.EditingFormValueCell.js-error').length > 0) validationFunction($el, callback);
        });
};

// detail form field bind and validation
const initDetailFormUpdateAction = fieldTypes => {
    const $form = $('[class*="form-generic"]');
    if ($form.length === 0) return;

    const $buttonWraper = $form.find('.submit-button-wrapper .EditingFormButtonCell');
    const toggleButtonError = respon => {
        $buttonWraper.addClass('Error');

        if (respon) {
            if ($form.find('.js-error').length === 0) $buttonWraper.removeClass('Error');
        }
    };

    // validate input-* [text, phone, number, postcode, cvc, checkbox]
    for (let i = 0; i < fieldTypes.length; i += 1) {
        if (typeof (fieldTypes[i].func) === 'function') {
            validateInputByType($form, fieldTypes[i].type, fieldTypes[i].func, toggleButtonError);
        }
    }
};

const onPopUpSubmit = $form => {
    // eslint-disable-$(form);next-line
    const first = $form.find('.first-name input').val();
    const last = $form.find('.last-name input').val();
    const email = $form.find('.email input').val();
    const dAmt = $form.find('.amount input').val();

    const formPopup = {
        first,
        last,
        email,
        dAmt
    };

    if (dAmt !== '' && dAmt !== undefined) {
        // eslint-disable-next-line
        sessionStorage.setItem('dAmt', Base64.encode(dAmt));
    }

    // eslint-disable-next-line
    javascript: __doPostBack('PopUpBtnSubmit', JSON.stringify(formPopup));
};

// init on submit next button - only the ones without recaptcha enabled
const initSubmitButton = () => {
    const $form = $('[class*="form-generic"]');
    const $submit = $form.find('.js-form-validate');
    if ($submit.length === 0) return;

    $submit.click(e => {
        e.preventDefault();

        if (isValidDetail($form, endAbuseTypes())) {
            onPopUpSubmit($form);
            // return true;
        }
        return false;
    });
};

$(() => {
    initSubmitButton();
    initDetailFormUpdateAction(endAbuseTypes());
});



// WEBPACK FOOTER //
// ./src/components/form-generic/c-form-generic.js